@use '~/theme/theme' as *;

.filtersBox {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: spacing(1);
  row-gap: spacing(1.5);
  align-items: center;

  &.primaryFilters {
    padding-top: spacing(1);
    padding-bottom: spacing(1);
    flex-wrap: nowrap;
    align-items: flex-end;
  }
}

.secondaryFilters {
  display: grid;
  grid-template-rows: 0fr;
  transition: 250ms grid-template-rows;

  &[data-expanded='true'] {
    grid-template-rows: 1fr;
  }
}

.secondaryFiltersContent {
  min-height: 0;
  clip-path: inset(0 -100vmax 100% -100vmax);
  padding-top: 0;
  padding-bottom: 0;
  transition:
    250ms padding-top,
    250ms padding-bottom,
    250ms clip-path;
}

.secondaryFilters[data-expanded='true'] .secondaryFiltersContent {
  clip-path: inset(0 -100vmax 0 -100vmax);
  padding-top: spacing(1);
  padding-bottom: spacing(1);
}

.root {
  width: 100%;
}

.clearFiltersButton,
.moreFiltersButton {
  flex-shrink: 0;
}

.moreFiltersButtonWrapper {
  position: relative;
}

.moreFiltersCounterBadge {
  top: -4px;
  right: -6px;
  position: absolute;
}

.clearFiltersParentButton {
  max-width: fit-content;
}
